import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../common'

import * as recordAttribute from './record-attribute'

export const DOC = gql`
  ${recordAttribute.DOC}
  ${common.gql.mappings.fragments.mapping.DOC}
  fragment FragmentGeneralLedgerRecord on GeneralLedgerRecord {
    id
    attributes {
      ...FragmentGeneralLedgerRecordAttribute
    }
    originalMapping {
      ...FragmentRateMapping
    }
    applicableRuleIds
  }
`

const RULE_ID_TRANSFORMER = graphql.transformers.OUT.custom<
  string | Nullish,
  number | undefined
>(id => {
  if (TypeChecker.isNullish(id)) {
    return undefined
  }
  const _id = Number(id)
  return TypeChecker.isNumber(_id) ? _id : undefined
})

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentGeneralLedgerRecordFragment,
  ents.extra.rate.gl.Record
>(
  {
    applicableRuleIds: graphql.transformers.OUT.default(
      graphql.transformers.OUT.list(RULE_ID_TRANSFORMER, {
        onNullish: 'remove',
      }),
      [],
    ),
    attributes: graphql.transformers.OUT.default(
      graphql.transformers.OUT.list(recordAttribute.TRANSFORMER, {
        onNullish: 'remove',
      }),
      [],
    ),
    fsFunction: () => undefined,
    id: graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      ents.extra.rate.gl.Record.Id.isId,
      { warnOnly: true },
    ),
    originalMapping: common.gql.mappings.fragments.mapping.TRANSFORMER,
  },
  { lazy: true, onNullish: 'remove' },
)
